import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const CategoryButtons = () => {
    const { t } = useTranslation();

    const categories = [
        { key: 'quran', icon: '📖', label: t('categories.quran', 'Quran') },
        { key: 'hadith', icon: '📚', label: t('categories.hadith', 'Hadith') },
        { key: 'prophet', icon: '🕌', label: t('categories.prophet', 'Prophet') },
        { key: 'sahabas', icon: '👥', label: t('categories.sahabas', 'Sahabas') },
        { key: 'scholars', icon: '🎓', label: t('categories.scholars', 'Scholars') },
        { key: 'sects', icon: '🕌', label: t('categories.sects', 'Sects') },
        { key: 'legalSchools', icon: '⚖️', label: t('categories.legalSchools', 'Legal Schools') },
        { key: 'timeline', icon: '⏳', label: t('categories.timeline', 'Timeline') }
    ];

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {categories.map((category) => (
                <Link
                    key={category.key}
                    to={`/category/${category.key}`}
                    className="group relative overflow-hidden rounded-lg bg-white p-4 shadow-sm transition-all duration-300 hover:shadow-md"
                >
                    <div className="absolute inset-0 bg-gradient-to-r from-green-50 to-green-100 opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
                    <div className="relative flex flex-col items-center">
                        <span className="text-3xl mb-2 transform group-hover:scale-110 transition-transform duration-300">
                            {category.icon}
                        </span>
                        <h3 className="text-base font-medium text-gray-900 group-hover:text-green-700">
                            {category.label}
                        </h3>
                    </div>
                </Link>
            ))}
        </div>
    );
};

export default CategoryButtons; 